// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"63":"5d12737e","647":"247c2043"}[chunkId] + ".js";
};